module.exports = __webpack_public_path__ + "static/media/NUS_Sports_Camp_Logo.d51b83d1.png";